export const trackMetaEventById = (metaEventId: string, eventName: string) => {
  if (process.env.NEXT_PUBLIC_APP_ENV === "production") {
    // Fire Meta Pixel event
    if (typeof window !== "undefined" && "fbq" in window && typeof window.fbq === "function") {
      window.fbq("track", eventName, {}, { eventID: metaEventId });
    }
  }
};

